import { z } from 'zod'

export const ADMINSOLOCLASSCODESPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloClassCodesPostResponseSchema = z.unknown()
export type AdminSoloClassCodesPostResponse = z.infer<typeof adminSoloClassCodesPostResponseSchema>
